/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueTabComponent } from './sysque-tab.component';
import { DxTabPanelModule, DxTemplateModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueTabComponent],
  imports: [CommonModule, DxTabPanelModule, DxTemplateModule],
  exports: [SysqueTabComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueTabModule {}
